import { Controller } from "react-hook-form";
import libForm from "../../../../util/libForm";

function SelectSituacaoCompra({ id, control }) {
	return (
		<div className="content-select">
			<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-3  min-w-52">
				<label htmlFor="situacao-compra">Situação de Compra</label>
				<Controller
					name={id}
					control={control}
					defaultValue="S"
					render={({ field }) => (
						<select {...field} onKeyDown={(e) => libForm.EnterTab(e)}>
							<option value="S">JÁ COMPROU</option>
							<option value="">TODOS</option>
							<option value="N">NUNCA COMPROU</option>
						</select>
					)}
				/>
			</div>
		</div>
	);
}

export default SelectSituacaoCompra;
